import React from 'react';
import { Select, MenuItem, FormControl, Box, Typography } from '@mui/material';
import { useLanguage } from './LanguageContext';
import LanguageIcon from '@mui/icons-material/Language';

function LanguageSelector() {
  const { currentLanguage, languages, changeLanguage } = useLanguage();

  const handleChange = (event) => {
    changeLanguage(event.target.value);
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center',
      gap: 0.5,
      ml: 2
    }}>
      <LanguageIcon sx={{ color: 'white', fontSize: '1.2rem' }} />
      <FormControl size="small" sx={{ minWidth: 100 }}>
        <Select
          value={currentLanguage}
          onChange={handleChange}
          sx={{ 
            fontSize: '0.9rem',
            color: 'white',
            '.MuiOutlinedInput-notchedOutline': { 
              borderColor: 'rgba(255, 255, 255, 0.5)' 
            },
            '&:hover .MuiOutlinedInput-notchedOutline': { 
              borderColor: 'rgba(255, 255, 255, 0.8)' 
            },
            '.MuiSvgIcon-root': { 
              color: 'white' 
            },
            '& .MuiSelect-select': {
              paddingY: 0.5,
            }
          }}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 300,
              },
            },
          }}
        >
          {languages.map((lang) => (
            <MenuItem key={lang.code} value={lang.code}>
              <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <Typography variant="body2">{lang.nativeName}</Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default LanguageSelector; 